import moment from 'moment';
import type { CoreTypes } from '../../core';
import type { Group } from '../types/groups';

function _transformGroupMembers (
  members:  Group['groupMemberships'],
  options?: Pick<CoreTypes.Deep.Division, 'start' | 'end'>
) {
  return [
    ...new Set(
      members?.filter(member => {
        if (options?.end && member.startDate && !moment(member.startDate).isBefore(moment(options.end)))
          return false;
        if (options?.start && member.endDate && !moment(member.endDate).isAfter(moment(options.start)))
          return false;
        return true;
      })
        .map((member) => member.person.id)
        .filter(Boolean)
    )
  ];
}

export default (
  groups:   Group[],
  options?: Pick<CoreTypes.Deep.Division, 'start' | 'end'>
): CoreTypes.MixedWithoutInternalId.Group[] => {
  if (!Array.isArray(groups))
    throw new Error('(SS12000::From::Groups) Group input is not of array type', { cause: 'invalid_input' });

  return groups
    .map((group): CoreTypes.MixedWithoutInternalId.Group => ({
      ids:         group.id,
      displayName: group.displayName,
      ...group.groupType == 'Klass' && { species: 'class' },
      ...group.groupMemberships && {
        members: _transformGroupMembers(group.groupMemberships, options)
      }
    }));
};